import { useState } from 'react';
import { faqList } from '@/mocks/clsqData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-100/70 text-primary-700 rounded-full text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            您可能想知道
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            我们整理了客户最常询问的问题，帮助您更快了解clsq
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-3">
          {faqList.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer group"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 ${
                      openId === faq.id ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-5 md:px-6 pb-5 animate-in slide-in-from-top-2 duration-200">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}